import { createRouter } from '@tanstack/react-router'
import { eventsDetailRoute } from './EventDetailPage'
import { eventEditRoute } from './EventEditPage'
import { eventsRoute } from './EventsPage'
import { homeRoute } from './HomePage'
import rootRoute from './rootRoute'
import { adminScrapersRoute as adminScrapers } from './admin/AdminView'
import { adminScrapersManageRoute } from './admin/AdminScrapersView'
import { adminEntitiesRoute } from './admin/AdminEntitiesView'
import { adminEventViewRoute } from './admin/AdminEventsView'
import { adminAllEventsRoute } from './admin/AdminAllEventsView'
import { loginRoute } from './LoginPage'
import { signupRoute } from './SignupPage'
import { verifyEmailRoute } from './VerifyEmailPage'
import { forgotPasswordRoute } from './ForgotPasswordPage'
import { resetPasswordRoute } from './ResetPasswordPage'
import { contactRoute } from './ContactPage'
import { adminUsersRoute } from './admin/AdminUsersView'
import { adminProfilingRoute } from './admin/AdminProfilingView'
import { newEventRoute } from './NewEvent'
import { myEventsRoute } from './MyEvents'
import { profileRoute } from './ProfilePage'
import { entitiesPublicRoute } from './EntitiesPage'
import { initiativesRoute } from './InitiativesPage'
import { entityDetailRoute } from './EntityDetailPage'
import { entityCreateRoute } from './EntityCreatePage'
import { entityEditRoute } from './EntityEditPage'
import NotFound from '@/components/NotFound'

const routeTree = rootRoute.addChildren([
  homeRoute,
  adminEventViewRoute,
  adminAllEventsRoute,
  adminUsersRoute,
  adminScrapers,
  adminScrapersManageRoute,
  adminEntitiesRoute,
  adminProfilingRoute,
  eventsRoute,
  eventEditRoute,
  eventsDetailRoute,
  loginRoute,
  signupRoute,
  verifyEmailRoute,
  forgotPasswordRoute,
  resetPasswordRoute,
  contactRoute,
  newEventRoute,
  myEventsRoute,
  profileRoute,
  entitiesPublicRoute,
  initiativesRoute,
  entityDetailRoute,
  entityCreateRoute,
  entityEditRoute,
])

const router = createRouter({
  routeTree,
  context: {},
  defaultNotFoundComponent: () => {
    return <NotFound />
  },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultViewTransition: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
})

export default router
